import { ErrorsPage } from '@/components/shared/errors-page';
import loadIntlMessages from '@/logic/helpers/loadIntlMessages';
import { GetServerSideProps, GetServerSidePropsContext, NextPage } from 'next';

const NotfoundIcon = '/icons/shared/not-found-no-data.svg';

const SomeThingWentWrong: NextPage = () => {
  return (
    <ErrorsPage
      title='no_data.title'
      description='no_data.description'
      pageImage={NotfoundIcon}
    />
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { locale, defaultLocale } = context;

  return {
    props: {
      intlMessages: await loadIntlMessages(locale as string, defaultLocale),
    },
  };
};

export default SomeThingWentWrong;
